import React, {useEffect, useState, useRef, useContext} from 'react';
import {AppContext} from '../../../AppModule/Context';
import utilsService from '../../../services/utilsService';
import VIDABOO_CONSTANTS from '../../../config/consts';
import MeetingRecipientsComponentRender from './meetingRecipientsComponentRender';

const MeetingRecipientsComponent = ({
  requester = {},
  currentUserId = '',
  recipients = [],
  proposals = [],
  ...props
}) => {
  const context = useContext(AppContext);

  const recipientsWrapRef = useRef();
  const [sortedRecipients, setSortedRecipients] = useState([]);
  const [emailCopiedToastTimeout, setEmailCopiedToastTimeout] = useState(null);
  const [copiedEmailItemIdx, setCopiedEmailItemIdx] = useState(-1);
  const [isSeeGuestBtnClicked, setIsSeeGuestBtnClicked] = useState(false);
  const [isSeeAllProposalsClicked, setIsSeeAllProposalsClicked] =
    useState(false);
  const [showFadeInBottomBg, setShowFadeInBottomBg] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);

  useEffect(() => {
    if (!VIDABOO_CONSTANTS.NATIVE_APP) {
      window.addEventListener('click', handleOutsideEvent);
      return () => {
        window.removeEventListener('click', handleOutsideEvent);
        if (emailCopiedToastTimeout) {
          clearTimeout(emailCopiedToastTimeout);
        }
      };
    }
  }, [isSeeGuestBtnClicked, isSeeAllProposalsClicked]);

  useEffect(() => {
    setSelectedRowIndex(-1);
    if (proposals.length) {
      let recipientsWithProposals = [...recipients];
      recipientsWithProposals.sort(sortRecipientsUsingProposals);
      setSortedRecipients(recipientsWithProposals);
    } else {
      let prevRecipients = [...recipients];
      prevRecipients.sort(sortRecipients);
      setSortedRecipients(prevRecipients);
    }
  }, [recipients]);

  const handleOutsideEvent = (evt) => {
    if (isSeeGuestBtnClicked) {
      const parentDiv = document.getElementById('et-mrc-top-id');
      if (!parentDiv.contains(evt.target)) {
        setIsSeeGuestBtnClicked(false);
        if (recipientsWrapRef.current) {
          recipientsWrapRef.current.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      }
    }
    if (isSeeAllProposalsClicked) {
      setIsSeeAllProposalsClicked(false);
      if (recipientsWrapRef.current) {
        recipientsWrapRef.current.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    }
  };

  const handleCopyIcon = (recipientEmail, itemIdx) => {
    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      //this is handled in render
    } else {
      utilsService.copyTextToClipboard(recipientEmail);
    }
    const toastObj = utilsService.getToastObj('Copied');
    context.addToastObj(toastObj);
    if (emailCopiedToastTimeout) {
      clearTimeout(emailCopiedToastTimeout);
    }
    setCopiedEmailItemIdx(itemIdx);
    const timeout = setTimeout(() => {
      setCopiedEmailItemIdx(-1);
    }, VIDABOO_CONSTANTS.TOAST_MESSAGE_TIMES.MIN_TIME);
    setEmailCopiedToastTimeout(timeout);
  };

  const sortRecipients = (recipient1) => {
    if (recipient1.userId === currentUserId) return -1;
    else return 0;
  };

  const sortRecipientsUsingProposals = (recipient1, recipient2) => {
    const recipientOneProposals = proposals.filter(
      (proposal) => proposal.proposingUserId === recipient1.userId,
    );
    const recipientTwoProposals = proposals.filter(
      (proposal) => proposal.proposingUserId === recipient2.userId,
    );
    if (recipientOneProposals.length > recipientTwoProposals.length) return -1;
    else return 0;
  };

  return (
    <MeetingRecipientsComponentRender
      requester={requester}
      currentUserId={currentUserId}
      recipients={recipients}
      proposals={proposals}
      sortedRecipients={sortedRecipients}
      isSeeGuestBtnClicked={isSeeGuestBtnClicked}
      recipientsWrapRef={recipientsWrapRef}
      handleCopyIcon={handleCopyIcon}
      copiedEmailItemIdx={copiedEmailItemIdx}
      showFadeInBottomBg={showFadeInBottomBg}
      selectedRowIndex={selectedRowIndex}
      setIsSeeAllProposalsClicked={setIsSeeAllProposalsClicked}
      isSeeAllProposalsClicked={isSeeAllProposalsClicked}
      setShowFadeInBottomBg={setShowFadeInBottomBg}
      setIsSeeGuestBtnClicked={setIsSeeGuestBtnClicked}
      setSelectedRowIndex={setSelectedRowIndex}
      {...props}
    />
  );
};

export default MeetingRecipientsComponent;
